const CLASSNAME = 'has-mouse';

const state = {
  hasMouse: false,
};

function onKeyDown() {
  state.hasMouse = false;
  document.documentElement.classList.remove(CLASSNAME);
  window.removeEventListener('keydown', onKeyDown);
  // eslint-disable-next-line no-use-before-define
  window.addEventListener('mousemove', onMouseMove);
}

function onMouseMove() {
  state.hasMouse = true;
  document.documentElement.classList.add(CLASSNAME);
  window.removeEventListener('mousemove', onMouseMove);
  window.addEventListener('keydown', onKeyDown);
}

const destroy = function destroyListener() {
  window.removeEventListener('mousemove', onMouseMove);
  window.removeEventListener('keydown', onKeyDown);
};

const init = function initListener() {
  window.addEventListener('mousemove', onMouseMove);
  window.addEventListener('keydown', onKeyDown);
};

const getState = function getMouseState() {
  return { ...state };
};

export default {
  destroy,
  getState,
  init,
};
